<template>
	<div class="container-fluid">
		<div v-for="category in categories" :key="category.slug">
			<h5>{{category.name}}</h5>
			<season-vertical-component v-for="season in category.seasons" :key="season.slug"></season-vertical-component>
		</div>
	</div>
</template>
<script>
export default {
	name: 'index',
	props: ['categories'],
	data() {
		return {

		}
	}
}

</script>
<style lang="css" scoped>


</style>
